const createImage = url =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", error => reject(error));
    image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} image - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 */
export default async function getCroppedImg(imageSrc, pixelCrop, isApplyMonochromatic = false) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  if (isApplyMonochromatic) {
    const imgData = ctx.getImageData(
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    )
    for (var i = 0; i < imgData.data.length; i += 4) {
      var avg = (imgData.data[i] + imgData.data[i + 1] + imgData.data[i + 2]) / 3
      imgData.data[i] = avg
      imgData.data[i + 1] = avg
      imgData.data[i + 2] = avg
    }
    ctx.putImageData(imgData, 0, 0)
  }

  // As a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob(file => {
      resolve(file);
    }, "image/jpeg");
  });
}
